import Header from "../../components/AdminPortal/Header/Header";
import EditAssignmentComponent from "../../components/AdminPortal/Assignment/EditAssignment";
import { useGetSingleAssignmentQuery } from "../../features/assignment/assignmentApi";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
export default function EditAssignment() {
  useEffect(() => {
    document.title = "Edit Video - LWS Learning Portal";
  }, []);
  const { assignmentId } = useParams();
  const {
    data: assignment,
    isLoading,
    isError,
  } = useGetSingleAssignmentQuery(assignmentId);
  let content = null;
  if (isLoading) content = <p>Loading....</p>;
  if (!isLoading && isError) content = <p>Error</p>;
  if (!isLoading && !isError && assignment?.length > 0)
    content = <EditAssignmentComponent assignment={assignment[0]} />;
  return (
    <>
      <Header />
      <section className="py-6 bg-primary ">
        <div className="mx-auto px-5 lg:px-0" style={{ maxWidth: "45%" }}>
          <h4 className="mb-8 text-xl font-bold text-center">
            Please fillup the form to update assignment
          </h4>
          {content}
        </div>
      </section>
    </>
  );
}
